const cartItemsInitialState = {
    items: []
}

export const cartItems = (state = [], action) => {
    switch (action.type) {

        case "cartItems_loadData": {
            const payload = action.payload;
            return payload; 
        };
        case "cartItems_add": {
            const existingItemList = [...state];
            const payload = action.payload;


            if (existingItemList.length === 0) {
                // if cartIsEmpty
                existingItemList.push(payload);
                // console.log("in-1-empty items")
                return existingItemList;
            }
            // Item ID already exist in the cartlist
            // Find at frist that id already exist 
            const findIndex = existingItemList.findIndex(item => item.id === payload.id);
            // console.log("findIndex", findIndex);
            if (findIndex !== -1) {
                // item found
                //  alert("item  found");
                const findItem = existingItemList.find(item => item.id === payload.id);
                //  console.log("findItem", findItem);
                existingItemList[findIndex].qty = parseInt(findItem.qty) + parseInt(payload.qty);
                return existingItemList;

            } else {
                // item not found
                // alert("item Not found");
                existingItemList.push(payload);
                return existingItemList;
            }



            return existingItemList;



        };
        case "cartItems_handleChange": {
            // console.log("payload-", action.payload)
            const payload = action.payload;
            const existingItemList = [...state];
            existingItemList[payload.index][payload.filed_name] = payload.value;
            return existingItemList;
        };

        case "cartItems_remove": {
            const items = [...state];
            items[action.payload]["qty"] = 1;
            items.splice(action.payload, 1);
            return items;
        };
        case "cartItems_reset": return [];
        default: return state;
    }
}


export const orderId = (state = "", action) => {
    switch (action.type) {
        case "orderId_add": return action.payload; 
        case "orderId_remove": return "";
        default: return state;
    }
}


export const paid = (state = 0, action) => {
    switch (action.type) {
        case "paid_update": return action.payload; 
        default: return state;
    }
}
export const masterPaid = (state = "", action) => {
    switch (action.type) {
        case "masterPaid_update": return action.payload; 
        default: return state;
    }
}
export const discount = (state = 0, action) => {
    switch (action.type) {
        case "discount_update": return action.payload; 
        default: return state;
    }
}


export const transactionList = (state = [], action) => {
    switch (action.type) {
        case "transactionList_loadData": return action.payload; 
        case "transactionList_remove": {
            const items = [...state];
            items.splice(action.payload, 1);
            return items;
        };
        default: return state;
    }
}